import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col" }

import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import SubSection from "../common/SubSection.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GenericCostOfAdvice',
  setup(__props) {

const store = useStore();
const display = ref(false);

onMounted(() => {
    display.value = store.state.configuration.finishDisplaysGenericCostOfFinancialAdvice;
});


return (_ctx: any,_cache: any) => {
  return (display.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SubSection, {
            title: "What does financial advice cost?",
            "show-help": false
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("p", null, "In short, it depends on the advice needed. As an example, retirement advice on selecting a mix of products, providers and suitable investments may be around 1-2% of the value of your pots with a minimum fixed cost at lower pot levels.", -1),
              _createElementVNode("p", null, "To help, advisers offer a free or low cost meeting to start with. The Government also allows people in defined contribution pension schemes to withdraw up to £500 tax free from their pension pot to pay towards retirement advice, if your pension provider allows this.", -1)
            ])),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})